export const grey = {
  0: "#ffffff",
  50: "#fafafa",
  95: "#f2f2f2",
  100: "#f4f4f5",
  200: "#e4e4e7",
  300: "#d4d4d8",
  400: "#a1a1aa",
  500: "#71717a",
  600: "#52525b",
  700: "#3f3f46",
  800: "#27272a",
  900: "#18181b",
};

export const errorRed = "#EB5757";
export const greenLight = "#E6FBEF";
